import {
  ScaleBand,
  ScaleLinear,
  ScaleLogarithmic,
  ScaleTime,
  type ScaleSymLog,
} from 'd3-scale';

/**
 * Checks whether a scale is logarithmic.
 *
 * The logarithmic scales have a unique prop called 'base', so checking it we can detect the type.
 *
 * @param scale -
 */
export function isLogScale(
  scale:
    | ScaleLogarithmic<number, number>
    | ScaleSymLog<number, number>
    | ScaleLinear<number, number>
    | ScaleTime<number, number>,
): scale is ScaleLogarithmic<number, number> {
  return 'base' in scale;
}

/**
 * Checks whether a scale is symlog.
 *
 * The symlog scales have a unique prop called 'constant', so checking it we can detect the type.
 *
 * @param scale -
 */
export function isSymlogScale(
  scale:
    | ScaleLogarithmic<number, number>
    | ScaleSymLog<number, number>
    | ScaleLinear<number, number>
    | ScaleTime<number, number>,
): scale is ScaleSymLog<number, number> {
  return 'constant' in scale;
}

/**
 * Checks whether a scale is band.
 *
 * The band scales have a unique prop called 'paddingInner', so checking it we can detect the type.
 *
 * @param scale -
 */
export function isBandScale(
  scale:
    | ScaleLogarithmic<number, number>
    | ScaleSymLog<number, number>
    | ScaleLinear<number, number>
    | ScaleTime<number, number>
    | ScaleBand<string>,
): scale is ScaleBand<string> {
  return 'paddingInner' in scale;
}
